import UgcZoomControl from "./ZoomControl";

export default UgcZoomControl;
